import { render } from "./PageSectionHeading.vue?vue&type=template&id=88d224c6&scoped=true"
import script from "./PageSectionHeading.vue?vue&type=script&lang=js"
export * from "./PageSectionHeading.vue?vue&type=script&lang=js"

import "./PageSectionHeading.vue?vue&type=style&index=0&id=88d224c6&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d224c6"]])

export default __exports__